// data-aura-build: selle-cart
// Proteção de Entrega (liga/desliga), oferta do carrinho, limpeza da proteção sozinha, troca pelo kit maior e cronômetro de reserva.
// Usa o evento padrão do carrinho para o Horizon re-renderizar o carrinho lateral.
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const PP_ROW = '.selle-pp-row';

const drawerItems = () => document.querySelector('cart-items-component[data-drawer]');
const sectionIds = () => [...new Set([...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean))];
const cartRows = (comp) => [...comp.querySelectorAll('[ref="cartItemRows[]"]')];

async function addVariant(source, variantId) {
  return cartRequest(source, variantId, Theme.routes.cart_add_url, { items: [{ id: Number(variantId), quantity: 1 }] });
}

// Troca o kit do carrinho pelo kit seguinte numa chamada só (o atual zera, o novo entra com 1).
async function swapVariant(source, fromId, toId) {
  return cartRequest(source, toId, Theme.routes.cart_update_url, { updates: { [fromId]: 0, [toId]: 1 } });
}

async function cartRequest(source, variantId, url, payload) {
  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'cart',
    lines: [{ merchandiseId: String(variantId), quantity: 1 }],
    promise: deferred.promise,
  }));
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ ...payload, sections: sectionIds().join(','), sections_url: location.pathname }),
    }).then((r) => r.json());
    if (res.status) throw new Error(res.description || res.message || 'add failed');
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: cart.item_count, source: 'selle-cart', sections: res.sections, didError: false },
    });
  } catch (err) {
    deferred.reject(err);
    throw err;
  }
}

function removeProtection() {
  const comp = drawerItems();
  if (!comp || typeof comp.onLineItemRemove !== 'function') return false;
  const idx = cartRows(comp).findIndex((r) => r.matches(PP_ROW));
  if (idx < 0) return false;
  comp.onLineItemRemove(idx + 1);
  return true;
}

// Proteção sozinha no carrinho (a cliente tirou o produto): sai também.
let sweeping = false;
function sweepOrphan() {
  if (sweeping) return;
  const comp = drawerItems();
  if (!comp) return;
  const rows = cartRows(comp);
  if (!rows.length || !rows.every((r) => r.matches(PP_ROW))) return;
  sweeping = true;
  removeProtection();
  setTimeout(() => { sweeping = false; }, 1500);
}

document.addEventListener('click', async (event) => {
  const sw = event.target.closest?.('[data-selle-pp]');
  if (sw) {
    event.preventDefault();
    if (sw.getAttribute('aria-busy') === 'true') return;
    const on = sw.getAttribute('aria-checked') === 'true';
    sw.setAttribute('aria-checked', String(!on));
    sw.setAttribute('aria-busy', 'true');
    try {
      if (on) {
        if (!removeProtection()) sw.setAttribute('aria-checked', 'true');
      } else {
        await addVariant(sw, sw.dataset.sellePp);
      }
    } catch (e) {
      sw.setAttribute('aria-checked', String(on));
    } finally {
      setTimeout(() => sw.removeAttribute('aria-busy'), 600);
    }
    return;
  }
  const swap = event.target.closest?.('[data-selle-swap-to]');
  if (swap) {
    event.preventDefault();
    if (swap.getAttribute('aria-busy') === 'true') return;
    swap.setAttribute('aria-busy', 'true');
    try { await swapVariant(swap, swap.dataset.selleSwapFrom, swap.dataset.selleSwapTo); } catch (e) { /* o carrinho continua como estava */ } finally { swap.removeAttribute('aria-busy'); }
    return;
  }
  const add = event.target.closest?.('[data-selle-add]');
  if (add) {
    event.preventDefault();
    if (add.getAttribute('aria-busy') === 'true') return;
    add.setAttribute('aria-busy', 'true');
    try { await addVariant(add, add.dataset.selleAdd); } catch (e) { /* o carrinho continua como estava */ } finally { add.removeAttribute('aria-busy'); }
  }
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(() => {
    // espera o Horizon terminar de trocar o HTML do carrinho
    setTimeout(sweepOrphan, 450);
    setTimeout(sweepOrphan, 1200);
  }).catch(() => {});
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweepOrphan);
else sweepOrphan();

// Cronômetro "Compra reservada por": 10 minutos contados do primeiro produto no carrinho.
// O fim fica salvo no navegador: fechar/reabrir a aba continua de onde parou. Carrinho vazio zera a reserva.
const RESERVA_KEY = 'selle-reserva-fim';
const RESERVA_MS = 10 * 60 * 1000;
let reservaMem = null;
const lerFim = () => { try { return Number(localStorage.getItem(RESERVA_KEY)) || null; } catch (e) { return reservaMem; } };
const gravarFim = (v) => { reservaMem = v; try { v ? localStorage.setItem(RESERVA_KEY, String(v)) : localStorage.removeItem(RESERVA_KEY); } catch (e) { /* segue em memória */ } };

function tickReserva() {
  const timers = document.querySelectorAll('[data-selle-timer]');
  if (!timers.length) return;
  let fim = lerFim();
  if (!fim) { fim = Date.now() + RESERVA_MS; gravarFim(fim); }
  const resta = Math.max(0, fim - Date.now());
  const seg = Math.ceil(resta / 1000);
  const txt = `${String(Math.floor(seg / 60)).padStart(2, '0')}:${String(seg % 60).padStart(2, '0')}`;
  timers.forEach((t) => {
    t.classList.toggle('is-over', resta === 0);
    const c = t.querySelector('[data-selle-clock]');
    if (c && c.textContent !== txt) c.textContent = txt;
  });
}
// Carrinho sem máscara (vazio, ou compra finalizada): a próxima compra ganha 10 minutos novos.
function zerarSeVazio() {
  fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => { if (!cart.items.some((i) => i.handle !== 'protecao-de-entrega')) gravarFim(null); })
    .catch(() => {});
}
zerarSeVazio();
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(() => setTimeout(zerarSeVazio, 600)).catch(() => {});
});
tickReserva();
setInterval(tickReserva, 250);

